import { render, staticRenderFns } from "./HabilityTypeList.vue?vue&type=template&id=aaaa99e2"
import script from "./HabilityTypeList.vue?vue&type=script&lang=js"
export * from "./HabilityTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports